module.exports = __webpack_public_path__ + "img/3-detail.2dcfbde9.webp";